import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  basicFiltersContainer: {
    display: 'grid',
    columnGap: '4%',
    gridTemplateColumns: '3fr 1fr',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '3fr',
      marginBottom: 36
    }
  },
  form: {},
  dateSelectorForm: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 25
    }
  },
  inventoryTypeFormContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  inventoryTypeSelector: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minHeight: 100
  },
  inventoryTypeSelectorLabel: {
    marginRight: 100,
    [theme.breakpoints.down('sm')]: {
      marginRight: 59
    }
  },
  channelSelector: {
    flex: 1
  },
  inventoryTypeRadioGroup: {
    display: 'flex',
    flexDirection: 'row'
  },
  addMoreDateRangesButton: {
    // marginTop: 4
  },
  addMoreDateRangeIcon: {
    marginRight: 8
  },
  nonRestrictionOptions: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    columnGap: 8,
    marginTop: 37,
    [theme.breakpoints.down('sm')]: {
      gridTemplateRows: 'repeat(3, 1fr)',
      gridTemplateColumns: '1fr',
      gap: 24
    }
  },
  restrictionOptionsContainer: {
    marginTop: 42
  },
  DividerLine: {
    marginTop: 42
  },
  confirmButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 42
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))

export default useStyles
